import { render, staticRenderFns } from "./CapsuleToy.vue?vue&type=template&id=108d824c&"
import script from "./CapsuleToy.vue?vue&type=script&lang=js&"
export * from "./CapsuleToy.vue?vue&type=script&lang=js&"
import style0 from "./CapsuleToy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports